module.exports = __webpack_public_path__ + "static/media/medalhas2020-reputacao-22.68a52cb9.68a52cb9.png";